(function(window, document){
  function createHttpRequest()
  {
      if(window.ActiveXObject){
          return new ActiveXObject("Microsoft.XMLHTTP");  
      }
      else if(window.XMLHttpRequest){
          return new XMLHttpRequest();  
      }  
  }
  function AliLogTracker(url)
  {
      this.uri_ = url + '?APIVersion=0.6.0';
      this.params_=new Array();
      this.httpRequest_ = createHttpRequest();
  }
  AliLogTracker.prototype = {
      push: function(key,value) {
          if(!key || !value) {
              return;
          }
          this.params_.push(key);
          this.params_.push(value);
      },
      logger: function()
      {
          var url = this.uri_;
          var param = ''
          var k = 0;
          while(this.params_.length > 0)
          {
              if(k % 2 == 0)
              {
                param += '&' + encodeURIComponent(this.params_.shift());
              }
              else
              {
                param += '=' + encodeURIComponent(this.params_.shift());
              }
              ++k;
          }
          try
          {
              param = param.substr(1)
              this.httpRequest_.open("POST",url,true);
              this.httpRequest_.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;")
              this.httpRequest_.send(param);
          }
          catch (ex) 
          {
              if (window && window.console && typeof window.console.log === 'function') 
              {
                  console.log("Failed to log to ali log service because of this exception:\n" + ex);
                  console.log("Failed log data:", url);
              }
          }
          
      }
  };
  window.Tracker = AliLogTracker;
})(window, document);


// WEBPACK FOOTER //
// ./src/assets/js/loghub-tracking.js